export default __webpack_public_path__ + "static/media/photo_2021-04-04_19-52-33.3cb612e9.jpg";